// extracted by mini-css-extract-plugin
export default {"footerSection":"Footer_footerSection__W+gu0","footerCont":"Footer_footerCont__5glnE"};